import * as React from "react";
const SvgBbq = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M9.453 3.36c0-.028-.007-.089-.077-.194a.75.75 0 1 1 1.248-.832c.2.301.33.647.33 1.026 0 .378-.13.724-.33 1.025-.07.105-.077.166-.077.193 0 .028.007.089.077.194a.75.75 0 1 1-1.248.832 1.84 1.84 0 0 1-.33-1.026c0-.379.13-.724.33-1.025.07-.105.077-.166.077-.193Z"
      fill="currentColor"
    />
    <path
      d="M21.28 3.28a.75.75 0 0 0-1.06-1.06L15.44 7H4.679C3.752 7 3 7.752 3 8.679c0 2.868 1.91 5.29 4.528 6.063L5.29 20.997a.75.75 0 1 0 1.412.506l.359-1.003h8.067a2.251 2.251 0 1 0 1.632-2.947l-1.018-2.897A6.324 6.324 0 0 0 20 8.679C20 7.752 19.248 7 18.321 7h-.76l3.72-3.72Zm-4.524 15.906A.747.747 0 0 1 17.25 19a.75.75 0 1 1-.494.186Zm-1.294-.802a2.246 2.246 0 0 0-.334.616h-7.53l1.433-4.007c.096.005.193.007.29.007h4.358c.197 0 .392-.009.584-.027l1.2 3.41Zm.274-9.884h2.585c.1 0 .179.08.179.179a4.821 4.821 0 0 1-4.821 4.821H9.32A4.821 4.821 0 0 1 4.5 8.679c0-.1.08-.179.179-.179h11.057Z"
      fill="currentColor"
    />
    <path
      d="M12.376 3.166c.07.105.077.166.077.194 0 .027-.007.088-.077.193-.2.301-.33.646-.33 1.025 0 .38.13.725.33 1.026a.75.75 0 0 0 1.248-.832c-.07-.105-.077-.166-.077-.194 0-.027.007-.088.077-.193.2-.301.33-.647.33-1.025 0-.38-.13-.725-.33-1.026a.75.75 0 1 0-1.248.832Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgBbq;
